module.exports = __webpack_public_path__ + "media/images/white_logo-bad644592526c28de3ddb0dcbe700891.png";